import { VCarouselItem } from 'vuetify/lib/components/VCarousel';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCarouselItem,[_c('canvas',{ref:"canvas",class:_vm.$style.canvas,style:({ height: _vm.elementHeight }),attrs:{"width":_vm.width + 'px',"height":_vm.height + 'px'},on:{"v-resize":_vm.onResize}})])
}
var staticRenderFns = []

export { render, staticRenderFns }